import { useEffect, useState } from "react";

const KEY = "showClientAgeInYearsOnly";
const EVENT_NAME = "showClientAgeInYearsOnlyChanged";

// eslint-disable-next-line import/prefer-default-export
export const useShowClientAgeInYearsOnly = (): {
  showClientAgeInYearsOnly: boolean;
  setShowClientAgeInYearsOnly: (value: boolean) => void;
} => {
  const [showClientAgeInYearsOnly, setShowClientAgeInYearsOnly] = useState<boolean>(() => {
    const stored = localStorage.getItem(KEY);
    return stored === null ? false : stored === "true";
  });

  // use effects
  useEffect(() => {
    localStorage.setItem(KEY, String(showClientAgeInYearsOnly));
    window.dispatchEvent(new Event(EVENT_NAME));
  }, [showClientAgeInYearsOnly]);

  useEffect(() => {
    const sync = () => {
      setShowClientAgeInYearsOnly(localStorage.getItem(KEY) === "true");
    };

    const handleStorage = (e: StorageEvent) => {
      if (e.key === KEY) {
        sync();
      }
    };

    window.addEventListener(EVENT_NAME, sync);
    window.addEventListener("storage", handleStorage);

    return () => {
      window.removeEventListener(EVENT_NAME, sync);
      window.removeEventListener("storage", handleStorage);
    };
  }, []);

  return { showClientAgeInYearsOnly, setShowClientAgeInYearsOnly };
};
